import { Controller } from "@hotwired/stimulus";

// Abre el messenger de Intercom desde el launcher custom (item "Contactar a
// soporte" del dropdown del header). El boot lo hace el snippet del layout
// (layouts/manage/_intercom.html.erb) — aqui solo se dispara show().
export default class extends Controller {
  show(event) {
    event.preventDefault();
    if (window.Intercom) window.Intercom("show");
  }
}
